export const serviceName = 'entityCardDetails';
